import type { SVGProps } from 'react';
const SvgVideoCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M29.5 9.86316L20.9091 15.9995L29.5 22.1359V9.86316Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.4545 7.40906H4.95448C3.59888 7.40906 2.49994 8.508 2.49994 9.8636V22.1363C2.49994 23.4919 3.59888 24.5909 4.95448 24.5909H18.4545C19.8101 24.5909 20.909 23.4919 20.909 22.1363V9.8636C20.909 8.508 19.8101 7.40906 18.4545 7.40906Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default SvgVideoCamera;
